module.exports = __webpack_public_path__ + "img/business_travel_insurance.8e9ed036.webp";